export function isEqual(value: any, target: any): Error | undefined {
  if (value?.trim() !== target?.trim()) {
    return new Error(`Value should be "${target}"`);
  }
}
